// extracted by mini-css-extract-plugin
export var aboutHeader = "homePage-module--aboutHeader--7WuPL";
export var aboutHeroAvatar = "homePage-module--aboutHeroAvatar--NoZ6U";
export var aboutHeroBadge = "homePage-module--aboutHeroBadge--vO7Qz";
export var aboutHeroBadges = "homePage-module--aboutHeroBadges--JlVsW";
export var aboutHeroCopy = "homePage-module--aboutHeroCopy--tb3Xq";
export var aboutHeroGrid = "homePage-module--aboutHeroGrid--D7vG6";
export var aboutHeroIdentity = "homePage-module--aboutHeroIdentity--cP2CT";
export var aboutHeroLocation = "homePage-module--aboutHeroLocation--xjpDR";
export var aboutHeroProfile = "homePage-module--aboutHeroProfile--DnuNz";
export var aboutHeroSection = "homePage-module--aboutHeroSection--xLmpX";
export var aboutHeroSocial = "homePage-module--aboutHeroSocial--pQE9W";
export var activityStrip = "homePage-module--activityStrip--AsDUc";
export var awardsDivider = "homePage-module--awardsDivider--iLJjR";
export var awardsToggleButton = "homePage-module--awardsToggleButton--m-qh+";
export var hiddenAwardsContainer = "homePage-module--hiddenAwardsContainer--lsVtQ";
export var homePageBody = "homePage-module--homePageBody--UBvdP";
export var homepageSection = "homePage-module--homepageSection--dp4tl";
export var interestsHeading = "homePage-module--interestsHeading--0pgd1";
export var listItem = "homePage-module--listItem--hnGwi";
export var newsContent = "homePage-module--newsContent--HDZ0r";
export var newsDate = "homePage-module--newsDate--S2X8j";
export var newsItem = "homePage-module--newsItem--UYvDa";
export var newsList = "homePage-module--newsList--3DbFo";
export var quickLink = "homePage-module--quickLink--XzUT8";
export var quickLinks = "homePage-module--quickLinks--68i5m";
export var rangeEducation = "homePage-module--rangeEducation--RFekS";
export var rangeEducationDate = "homePage-module--rangeEducationDate--qkbT2";
export var rangeEducationMeta = "homePage-module--rangeEducationMeta--JQj1v";
export var rangeEducationTitle = "homePage-module--rangeEducationTitle--fnehj";
export var rangeExperience = "homePage-module--rangeExperience--V6TFb";
export var rangeExperienceContent = "homePage-module--rangeExperienceContent--+Gd8P";
export var rangeExperienceDate = "homePage-module--rangeExperienceDate--Zb9T3";
export var rangeExperienceDescription = "homePage-module--rangeExperienceDescription--C65G+";
export var rangeExperienceMeta = "homePage-module--rangeExperienceMeta--QWv+t";
export var rangeExperienceTitle = "homePage-module--rangeExperienceTitle--jDChZ";
export var rangeExperiences = "homePage-module--rangeExperiences--Pw5vU";
export var rangeKicker = "homePage-module--rangeKicker--iU5XC";
export var rangeRail = "homePage-module--rangeRail--JAEoF";
export var rangeTimeline = "homePage-module--rangeTimeline--GUSl9";
export var rangeTimelineGroup = "homePage-module--rangeTimelineGroup--mgdA5";
export var rangeTimelineOrphans = "homePage-module--rangeTimelineOrphans--N6+hj";
export var rsButton = "homePage-module--rs-button--iR-Ba";
export var sectionHeading = "homePage-module--sectionHeading--JriqM";
export var timelineEnter = "homePage-module--timeline-enter--ZThil";
export var timelineLeave = "homePage-module--timeline-leave--Jig88";